<template>
  <div>
    <v-row id="title" align="center">
      <v-col cols="1" xl="1" class="retour">
        <v-btn @click="$router.go(-1)">
          <v-icon left>fa-caret-left</v-icon>RETOUR
        </v-btn>
      </v-col>
      <v-col align-self="center" cols="5">
        <h1>{{ titlePage.toUpperCase() }}</h1>
      </v-col>

      <v-col
        v-if="this.$route.name == 'client'"
        align-self="center"
        class="desactiver_client"
        cols="5"
      >
        <v-row justify="end">
          <v-btn
            v-if="
              currentTab == 0 &&
              canManage
            "
            class="modifier_client"
            :elevation="0"
            @click="toModifier()"
          >
            <i class="fas fa-user-edit"></i>
            <div class="font_btn pl-2">Modifier ce client</div>
          </v-btn>

          <v-btn
            v-if="
              currentTab == 0 &&
              id_statut_entreprise == 1 &&
              canManage
            "
            class="fusion_btn"
            :elevation="0"
            @click="fusionDialog = true"
          >
            <i class="fas fa-code-branch"></i>
            <div class="font_btn pl-2">Fusionner avec un prospect</div>
          </v-btn>

          <v-btn
            v-if="
              currentTab == 0 &&
              $store.state.entreprise.actif &&
              canManage
            "
            class="disable_client"
            :elevation="0"
            @click="dialog = true"
          >
            <i class="fas fa-times"></i>
            <div class="font_btn">Désactiver ce client</div>
          </v-btn>
          <v-btn
            v-if="
              currentTab == 0 &&
              !$store.state.entreprise.actif &&
              canManage
            "
            class="active_client"
            :elevation="0"
            @click="dialogActive = true"
          >
            <i class="fas fa-times"></i>
            <div class="font_btn">Activer ce client</div>
          </v-btn>
        </v-row>

        <Popup
          :dialog="dialog"
          :text="desactiveEntreprise"
          :actions="actionsActive"
          @transform="archiver(idClientEnCours)"
          @nothing="dialog = false"
          class="popup"
        ></Popup>

        <Popup
          :dialog="dialogActive"
          :text="ActiveEntreprise"
          :actions="actionsActive"
          @transform="archiver(idClientEnCours)"
          @nothing="dialogActive = false"
          class="popup"
        ></Popup>

        <FusionSearchDialog
          v-model="fusionDialog"
          :idStatutEntreprise="id_statut_entreprise"
          @select="onFusionSelect"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "../../api/entreprise";
import Popup from "./../shared/Popup";
import FusionSearchDialog from "@/components/Fusion/FusionSearchDialog";

export default {
  components: {
    Popup,
    FusionSearchDialog,
  },
  name: "titlePage",
  props: [
    "titlePage",
    "idClientEnCours",
    "currentTab",
    "users",
    "id_statut_entreprise",
  ],
  data() {
    return {
      dialog: false,
      message: "",
      dialogActive: false,
      fusionDialog: false,
      ActiveEntreprise: "Souhaitez vous activer ce client ?",
      actionsActive: {
        actions: [
          {
            btn: "OUI",
            event: "transform",
          },
          {
            btn: "NON",
            event: "nothing",
          },
        ],
      },
      desactiveEntreprise: "Ëtes vous sur de vouloir désactiver ce client",
    };
  },

  computed: {
    // #1124 : écriture de la fiche client (administrateurs : tous ; commerce : ses clients)
    canManage() {
      return this.$peut('fiche_client', 'ecriture', this.$estAffecte(this.users));
    },
  },

  created() {},

  methods: {
    toModifier() {
      this.$router.push({
        name: "modifier_client",
        params: { id_entreprise: this.$route.params.id_entreprise },
      });
    },
    onFusionSelect(entreprise) {
      this.$router.push({
        name: 'fusion_preview',
        params: {
          id_entreprise: this.$route.params.id_entreprise,
          source_id: String(entreprise.id_entreprise),
        },
      });
    },
    archiver(id) {
      api.archiverEntreprise(id).then((res) => {
        this.dialogActive = false;
        this.dialog = false;
        this.$store.commit(
          "upadateActifEntreprise",
          !this.$store.state.entreprise.actif
        );
        this.message = res.data.message;
      }).catch(() => {
        this.$store.dispatch('notify', { message: 'Erreur lors de la mise à jour' });
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/variables.scss";
#title {
  background-color: $background-color-blue;
  text-align: left;
  margin-right: 0;
}

.popup {
  display: flex;
  flex-direction: column;
}

.retour {
  padding-left: 0;
  .v-btn.v-btn--has-bg {
    background-color: #55aacf;
    color: #fff;
    font-size: 1.1em;
    font-weight: bold;
    border-radius: 0 40px 40px 0;
  }
}
h1 {
  padding-left: 80px;
  color: #fff;
  font-size: 2em;
  font-weight: 900;
}
.color_red {
  color: #ec0403;
  background-color: #fff;
  border-radius: 10px;
  border-color: #ec0403;
}
.fusion_btn {
  background-color: #7b1fa2 !important;
  border-radius: 60px;
  font-weight: bold;
  color: #fff !important;
  margin-right: 10px;
}

.disable_client {
  background-color: #ec0403 !important;
  border-radius: 60px;
  font-weight: bold;
}

.active_client {
  background-color: orange !important;
  border-radius: 60px;
  font-weight: bold;
}

.modifier_client {
  background-color: #61bb45 !important;
  border-radius: 60px;
  font-weight: bold;
}

button.modifier_client.v-btn.v-btn--has-bg.theme--light.elevation-0.v-size--default {
  margin-right: 10px;
}
button.disable_client.v-btn.v-btn--has-bg.theme--light.elevation-0.v-size--default {
  margin-right: 10px;
}

.theme--light.v-btn.v-btn--has-bg {
  color: white;
  font-size: 1rem;
}
.font_btn {
  font-size: 0.64vw;
  text-transform: none;
}
.color_blue {
  color: #0b87ba;
}
::v-deep .card_border.v-card.v-sheet.theme--light {
  border-radius: 22px !important;
}

.btn_choice {
  min-width: 110px !important;
  background-color: #0b87ba;
  padding: 1.2em 3em;
  color: #fff;
  font-size: 1em;
  font-weight: bold;
  margin-bottom: 1em;
  ::v-deep span {
    letter-spacing: 0;
  }
}
.green {
  color: #3ec487;
  background-color: white !important;
}
.padd_modal {
  padding: 60px 0 0 0 !important;
}

.font_modal {
  font-size: initial;
}
.v-dialog > .v-card > .v-card__actions {
  padding: 0px 0px 50px 0 !important;
}
.desactiver_client.col.col-5.align-self-center {
  max-width: 100%;
  flex: 1;
}
img.logo {
  padding-right: 10px;
}
svg.svg-inline--fa.fa-user-edit.fa-w-20 {
  width: 2em;
}
svg.svg-inline--fa.fa-times.fa-w-11 {
  padding-right: 10px;
  height: 20px;
  width: 26px;
}
</style>
